import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { ClientIdPasswordList } from "../../../assets/images";
import { GetClientIdPasswordManagerListPayloadType } from "../../../commonTypes/stcoToolsType";
import {
  CommonHeader,
  ContentArea,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  SearchBar,
  TableLoader,
} from "../../../components/commons";
import IdPasswordManagerTable from "../../../components/StcoTools/IdPasswordManager/IdPasswordManagerTable/IdPasswordManagerTable";
import { ID_PASSWORD_MANAGER_HEADERS } from "../../../constant/tableHeadersConstants/stcoTools/idPasswordManagerTableHeader";
import useDebounce from "../../../customHooks/useDebounce";
import { getAllFinacUsersAction, resetSession } from "../../../redux/auth";
import {
  FinacUsersType,
  LoginResponseType,
} from "../../../redux/auth/authTypes";
import { RootState } from "../../../redux/rootReducers";
import {
  getClientIdPasswordManagerListAction,
  resetClientIdPasswordManagerList,
  resetIdPasswordManagerError,
  resetIdPasswordManagerSuccess,
  resetTotalClientCountList,
} from "../../../redux/stcoTools";
import {
  IdPasswordManagerListType,
  SelectedFilterType,
} from "../../../redux/stcoTools/stcoToolsType";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import IdPasswordFilter from "../../../components/StcoTools/IdPasswordManager/IdPasswordFilter/IdPasswordFilter";
import { ClientListType } from "../../Scheduling/ScheduleReports/ClientVsUserScheduling";
import { UserListType } from "../../../components/DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import { OptionsType } from "../../../commonTypes/universalTypes";

type AppProps = {
  history: any;
  token: string | null;
  message: string | null;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  totalCount: number | null | undefined;
  fetching: boolean;
  loginData: LoginResponseType;
  userFetching: boolean;
  finacUsersList: [] | FinacUsersType[] | any;
  clientIdPasswordList: [] | IdPasswordManagerListType[];
  dispatchResetSession: () => void;
  dispatchResetIdPasswordManagerError: () => void;
  dispatchResetIdPasswordManagerSuccess: () => void;
  dispatchClientIdPasswordManagerListAction: (
    data: GetClientIdPasswordManagerListPayloadType
  ) => void;
  dispatchResetClientIdPasswordManagerList: () => void;
  dispatchResetTotalClientCountList: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
};

const ClientIdPasswordManagerList = ({
  history,
  token,
  success,
  statusCode,
  error,
  message,
  totalCount,
  fetching,
  loginData,
  finacUsersList,
  clientIdPasswordList,
  dispatchGetAllFinacUsersAction,
  dispatchClientIdPasswordManagerListAction,
  dispatchResetClientIdPasswordManagerList,
  dispatchResetSession,
  dispatchResetIdPasswordManagerError,
  dispatchResetIdPasswordManagerSuccess,
  dispatchResetTotalClientCountList,
  userFetching,
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const company_name = history?.location?.state?.company_name;
  const persistUserSelected = history?.location?.state?.userSelected;
  const persistCategorySelected = history?.location?.state?.selectCategory;
  const persistSearchData = history?.location?.state?.searchData;
  const persistFileAttachmentStatus = history?.location?.state?.fileAttachmentStatus

  const [searchData, setsearchData] = useState(persistSearchData?persistSearchData :"");
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [deleteIdPasswordId, setDeleteIdPasswordId] = useState<number>(0);
  const [clientIdPasswordManagerListData, setClientIdPasswordManagerListData] =
    useState<any>([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchClear, setSearchClear] = useState(false);

  const [finalUserList, setFinalUserList] = useState<UserListType[] | []>([]);
  const [filter, setFilter] = useState<boolean>(false);
  const [text, setText] = useState("");
  const [userText, setUserText] = useState("");
  const [loadCondition, setLoadCondition] = useState(true);
  const [finacApiCall, setFinacApiCall] = useState(false);
  const [userOffset, setUserOffset] = useState(0);
  const [selectCategory, setSelectCategory] = useState<OptionsType>({
    value: null,
    label: "Select Category...",
  });
  const [userSelected, setUserSelected] = useState<ClientListType>({
    value: null,
    label: "Select User...",
  });
  const [fileAttachmentStatus, setFileAttachmentStatus] = useState("");
  const [fileAttachementStatusValue, setfileAttachmentStatusValue] =
    useState<string>("");
  const isFilterSelected = useRef<SelectedFilterType>({
    client: false,
    user: persistUserSelected?.value ? true : false,
    category: persistCategorySelected?.value ? true : false,
    fileAttachment:persistFileAttachmentStatus ? true:false

  });

  //====================User Management=============================
  const [
    isEditClientIdPasswordManagerPresent,
    setIsEditClientIdPasswordManagerPresent,
  ] = useMenuCheck();
  const [
    isAddClientIdPasswordManagerPresent,
    setIsAddClientIdPasswordManagerPresent,
  ] = useMenuCheck();
  const [
    isClientIdPasswordManagerListPresent,
    setClientIsIdPasswordManagerListPresent,
  ] = useMenuCheck();
  //=================================================================

  useEffect(() => {
    dispatchResetClientIdPasswordManagerList();
    dispatchResetIdPasswordManagerError();
    dispatchResetIdPasswordManagerSuccess();
    dispatchResetTotalClientCountList();
    setIsEditClientIdPasswordManagerPresent("Edit Client Id/Password ", "menu");
    setIsAddClientIdPasswordManagerPresent("Add Client Id/Password ", "menu");
    setClientIsIdPasswordManagerListPresent("Client Id/Password  List", "menu");
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (persistUserSelected?.value || persistCategorySelected?.value ||   persistFileAttachmentStatus) {
      setFilter(true);
      if (persistCategorySelected?.value) {
        setSelectCategory(persistCategorySelected);
      }
      if (persistUserSelected?.value) {
        setUserSelected(persistUserSelected);
      }
      if(persistFileAttachmentStatus){
        setfileAttachmentStatusValue(persistFileAttachmentStatus)
      }
      setOffset(0);
    }
  }, [persistUserSelected, persistCategorySelected,persistFileAttachmentStatus]);

  const checkUserBottom = (e: any) => {
    setLoadCondition(false);
    setUserOffset((prv) => prv + limit);
  };

  const handleCategoryChange = (e: any) => {
    setSelectCategory(e);
  };

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: userOffset,
        limit,
        user_type: "stco_users",
        status: 1,
        client_code,
        search_term: userText,
      };
      if (offset <= finacUsersList?.total_count && finacApiCall) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
    //eslint-disable-next-line
  }, [userOffset]);

  const fetchNewUserData = (search: string) => {
    const finalData = {
      token,
      offset: userOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      client_code,
      search_term: userText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  // Custom debounce hook for search data
  useDebounce(
    () => {
      if (userText) {
        fetchNewUserData(userText);
      } else {
        setFinacApiCall(true);
        const finalData = {
          token,
          offset: 0,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: userText,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [userText]
  );

  useEffect(() => {
    if (token && clientIdPasswordList?.length && totalCount) {
      let finalData = {
        token,
        limit: limit,
        client_code,
        offset,
        searchData : searchData?searchData:persistSearchData,
        category: selectCategory?.value
          ? selectCategory?.value
          : persistCategorySelected?.value,
        accessMemberId: userSelected?.value
          ? userSelected?.value
          : persistUserSelected?.value,
          attachments:
          fileAttachementStatusValue !== undefined && fileAttachementStatusValue !== null
            ? fileAttachementStatusValue
            : persistFileAttachmentStatus,
      };
      if (offset < totalCount) {
        dispatchClientIdPasswordManagerListAction(finalData);
      }
    } else if (token && offset === 0 ) {
      let finalData = {
        token,
        limit: limit,
        client_code,
        offset,
        searchData : searchData?searchData:persistSearchData,
        category: selectCategory?.value
          ? selectCategory?.value
          : persistCategorySelected?.value,
        accessMemberId: userSelected?.value
          ? userSelected?.value
          : persistUserSelected?.value,
          attachments:
          fileAttachementStatusValue !== undefined && fileAttachementStatusValue !== null
            ? fileAttachementStatusValue
            : persistFileAttachmentStatus,
      };
      dispatchClientIdPasswordManagerListAction(finalData);
    }
    //eslint-disable-next-line
  }, [offset]);

  //infinite Scroll
  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight) {
      setOffset(offset + limit);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    //eslint-disable-next-line
  }, [clientIdPasswordList]);

  const fetchNewData = (search: string) => {
    if (token) {
      let finalData = {
        token,
        offset,
        limit,
        client_code,
        searchData: search,
        category: selectCategory?.value,
        accessMemberId: userSelected?.value,
        attachments:
        fileAttachementStatusValue !== undefined && fileAttachementStatusValue !== null
          ? fileAttachementStatusValue
          : persistFileAttachmentStatus,
      };

      if (token) {
        setSearchClear(true);

        if (offset === 0) {
          dispatchClientIdPasswordManagerListAction(finalData);
          setOffset(0);
        } else {
          setOffset(0);
        }
      }
    }
  };

  useEffect(() => {
    if (finacUsersList?.data?.length) {
      const data = finacUsersList?.data?.filter(
        (e: any) => e.user_id !== loginData?.user_id
      );
      let finalUserData = data?.map((user: FinacUsersType) => {
        return {
          value: user?.user_id,
          label: `${user?.first_name} ${user?.last_name}`,
          image: user?.profile_pic?.file_url,
        };
      });
      if (userOffset > 0) {
        setFinalUserList([...finalUserList, ...finalUserData]);
      } else {
        setFinalUserList([...finalUserData]);
      }
    }
    //eslint-disable-next-line
  }, [finacUsersList]);

  useEffect(() => {
    if (clientIdPasswordList?.length === 0) {
      setClientIdPasswordManagerListData(clientIdPasswordList);
    } else if (offset > 0) {
      if (clientIdPasswordList?.length > 0) {
        setClientIdPasswordManagerListData((prv: any) => [
          ...prv,
          ...clientIdPasswordList,
        ]);
      }
    } else {
      setClientIdPasswordManagerListData(clientIdPasswordList);
    }
    //eslint-disable-next-line
  }, [clientIdPasswordList]);

  const onMenuClose = () => setLoadCondition(true);
  // Custom debounce hook for search data
  useDebounce(
    () => {
      if(finacApiCall){
        if (searchData) {
          fetchNewData(searchData);
        }else{
          delete  history?.location?.state?.searchData
          let finalData = {
            token,
            offset,
            client_code,
            limit,
            searchData:"",
            category: selectCategory?.value,
            accessMemberId: userSelected?.value,
            attachments:fileAttachementStatusValue

          };
          if (searchData?.length === 0) {
            dispatchClientIdPasswordManagerListAction(finalData);
            setOffset(0);
          }
        }
      }
     
    },
    500,
    [searchData]
  );

  const handleSearch = (e: any) => {
    setsearchData(e.target.value);
  };

  const handleEditIdPasswordData = (data: any) => {
    history.push({
      pathname: `/client-id-password-manager/edit/${client_code}`,
      state: { data, client_code, company_name, userSelected, selectCategory , searchData},
    });
  };

  const handleShowConfirmationModal = (id: number) => {
    setShowConfirmationModal(!showConfirmationModal);
    setDeleteIdPasswordId(id);
  };

  const handleFilter = (type?: string) => {
    dispatchResetClientIdPasswordManagerList();
    setClientIdPasswordManagerListData([]);
    if (type != "clear") {
      setFilter(true);
    } else {
      delete history?.location?.state?.userSelected;
      delete history?.location?.state?.selectCategory;
      delete history?.location?.state?.fileAttachmentStatus

    }

    let finalData = {
      token,
      offset: 0,
      limit,
      client_code,
      searchData,
      category: type === "clear" ? null : selectCategory?.value,
      accessMemberId: type === "clear" ? null : userSelected?.value,
      attachments: type === "clear" 
      ? null 
      : fileAttachementStatusValue !== undefined && fileAttachementStatusValue !== null
        ? fileAttachementStatusValue 
        : null,
    };

    if (token) {
      if (offset === 0) {
        dispatchClientIdPasswordManagerListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleUserChange = (e: any) => {
    setUserSelected(e);
  };

  //Future use
  //   const deleteIdPasswordRecord = (record_id: number) => {
  //     let data = {
  //       record_id,
  //       token
  //     };
  //     dispatchDeleteIdPasswordManagerAction(data);
  //     setRemove(true)
  //   };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetIdPasswordManagerError();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader
            title="Id Password Manager"
            company_name={company_name}
            client_code={client_code}
          />
        </div>
        {isAddClientIdPasswordManagerPresent && (
          <div className="col-md-6">
            <div className="d-flex flex-row justify-content-end mr-5">
              {!!clientIdPasswordList?.length && (
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    history.push({
                      pathname: `/client-id-password-manager/add/${client_code}`,
                      state: { client_code, company_name , userSelected:undefined,selectCategory:undefined , searchData:undefined},
                    })
                  }
                >
                  + Add ID/Password
                </button>
              )}
            </div>
          </div>
        )}
      </div>
      {isClientIdPasswordManagerListPresent && (
        <ContentArea>
          <div className="d-flex align-items-center">
            <div className="col-md-11">
              <SearchBar
                handleSearch={handleSearch}
                placeHolder={`Search `}
                value={searchData}
              />
            </div>
            <IdPasswordFilter
              type="module"
              checkUserBottom={checkUserBottom}
              onMenuClose={onMenuClose}
              setText={setText}
              loadCondition={loadCondition}
              setLoadCondition={setLoadCondition}
              handleFilter={handleFilter}
              setUserSelected={setUserSelected}
              filter={filter}
              setFilter={setFilter}
              userFetching={userFetching}
              userSelected={userSelected}
              finalUserList={finalUserList}
              handleUserChange={handleUserChange}
              setUserText={setUserText}
              setUseroffset={setUserOffset}
              selectCategory={selectCategory}
              setSelectCategory={setSelectCategory}
              handleCategoryChange={handleCategoryChange}
              isFilterSelected={isFilterSelected}
              fileAttachmentStatus={fileAttachmentStatus}
              setFileAttachmentStatus={setFileAttachmentStatus}
              fileAttachementStatusValue={fileAttachementStatusValue}
              setfileAttachmentStatusValue={setfileAttachmentStatusValue}
            />
          </div>

          {!clientIdPasswordList?.length && !fetching ? (
            <div className="mt-5">
              <EmptyListPage
                title="No Id Password Manager List"
                text={
                  isAddClientIdPasswordManagerPresent
                    ? "Start adding Id Password by clicking the button below"
                    : ""
                }
                showAddButton={isAddClientIdPasswordManagerPresent}
                image={ClientIdPasswordList}
                imageWidth="30%"
                buttonTitle="+ Add ID/Password"
                onButtonClick={() =>
                  history?.push({
                    pathname: `/client-id-password-manager/add/${client_code}`,
                    state: { client_code, company_name , userSelected:undefined,selectCategory:undefined , searchData : undefined},
                  })
                }
              />
            </div>
          ) : (
            <IdPasswordManagerTable
              fetching={fetching}
              loginData={loginData}
              offset={offset}
              handleShowConfirmationModal={handleShowConfirmationModal}
              tableHeaders={ID_PASSWORD_MANAGER_HEADERS}
              idPasswordManagerList={clientIdPasswordManagerListData}
              handleEditIdPasswordData={handleEditIdPasswordData}
              isEditClientIdPasswordManagerPresent={
                isEditClientIdPasswordManagerPresent
              }
            />
          )}
        </ContentArea>
      )}

      {offset == 0
        ? fetching && <Loader />
        : fetching && <TableLoader Rows={10} ColumnPerRow={8} />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  message: state.stcoTools.message,
  success: state.stcoTools.success,
  error: state.stcoTools.error,
  statusCode: state.stcoTools.statusCode,
  fetching: state.stcoTools.fetching,
  userFetching: state.auth.fetching,
  finacUsersList: state.auth.finacUsersList,
  clientIdPasswordList: state.stcoTools.getClientidPasswordManagerList,
  loginData: state.auth.loginData,
  totalCount: state.stcoTools.totalClientList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetIdPasswordManagerSuccess: () =>
    dispatch(resetIdPasswordManagerSuccess()),
  dispatchResetIdPasswordManagerError: () =>
    dispatch(resetIdPasswordManagerError()),
  dispatchClientIdPasswordManagerListAction: (
    data: GetClientIdPasswordManagerListPayloadType
  ) => dispatch(getClientIdPasswordManagerListAction(data)),
  dispatchResetClientIdPasswordManagerList: () =>
    dispatch(resetClientIdPasswordManagerList()),
  dispatchResetTotalClientCountList: () =>
    dispatch(resetTotalClientCountList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientIdPasswordManagerList);
